import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_searchable_select = _resolveComponent("searchable-select");
  return _openBlock(), _createBlock(_component_searchable_select, _mergeProps(_ctx.$attrs, {
    "label-field": $props.labelField,
    options: $options.sortedOptions,
    threshold: $props.threshold,
    "translation-field": $props.translationField
  }), null, 16, ["label-field", "options", "threshold", "translation-field"]);
}